import { MatDialogConfig } from '@angular/material/dialog';

export const RMS_DIALOG_SM_CONFIG: MatDialogConfig = {
  panelClass: ['rms-dialog', 'rms-dialog-sm'],
};

export const RMS_DIALOG_MD_CONFIG: MatDialogConfig = {
  panelClass: ['rms-dialog', 'rms-dialog-md'],
};

export const RMS_DIALOG_LG_CONFIG: MatDialogConfig = {
  panelClass: ['rms-dialog', 'rms-dialog-lg'],
};

export const RMS_DIALOG_FULL_SCREEN_CONFIG: MatDialogConfig = {
  panelClass: ['rms-dialog', 'rms-dialog-full-screen'],
};

export const RMS_DIALOG_POSITION_TOP: MatDialogConfig = {
  position: { top: '5px' },
};
